/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { Link, useLocation,useSearchParams } from "react-router-dom"
import Debounce from "../../../CommonMethods/Debounce"
import { limitReducer,resetArrays } from "../../../redux/MultiselectRows"
import Table from "./Components"
import Pagination from "../../../components/Pagination"
import Limit from "../../../components/Limit"
import GlobalContext from "../../../components/Context/GloablContext"
import CustomOverLay from "../../../components/CustomOverLay"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import Emptyscreen from "../../../components/EmptyScreen"
import ConfirmationPrompt from "../../../components/ConfirmationPrompt"
import AnimatedModel from "../../../components/Animation/AnimatedModel"
import TopBarIndividual from "./TopBar"
import { useEditOrgUserMutation, useExportOrganizationUsersMutation, useGetOrganizationUserQuery } from "../../../features/organizationUserSlice"
import { handleAddFilterValues ,handleIsUserScreen} from "../../../redux/systemConfigSlice"
import HelpGuideModal from "../../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'
import ProviderSearch from "../../ManageProvider/Components/AdvancedSearch"
import { resetProviderSearch, setProSearchApplied } from "../../../redux/providerSearchSlice"

export default function ManageOrganizationUser(){
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    const providerSearch = useSelector(state => state.providerSearchData);
    const searchApplied = useSelector((state) => state.providerSearchData.prosearchApplied);
    const viewId=useSelector(state=>state?.systemConfigData?.viewToUser)
    const [editUser]=useEditOrgUserMutation()
    const [exportOrganizationUsers]=useExportOrganizationUsersMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading,setLoading]=useState(false)
    const [isSortselected,setisSortSelected]=useState(false)
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [emptyField,setEmptyField]=useState(false);
    const orgId=useSelector(state=>state?.systemConfigData?.organization_id)
    const orgView_Id=useSelector(state=>state?.systemConfigData?.viewOrg_id)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const [datePartialFilled,setDatePartialFilled] = useState(false);
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    

    const initialState={
        "status":'',
        "permission_access":'',
    }
    const [filterValues,setFilterValues]=useState(initialState)
     

    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const {data,isFetching,isLoading,status}=useGetOrganizationUserQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    useEffect(() => {
        if(location.search===''){
            setSkip(true)
        }
        
        if(location.state!==null&&location.state!==''&&location?.state?.limit!==undefined&& !Array.isArray(location.state)){
            let params={};
            if(location?.state?.search!==''){
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'_id+desc',
                    'search':decodeURIComponent(location.state.search),
                    'search_mode':location.state.search_mode
                }
            }else{
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'_id+desc',
                }

            }
            setSearchParams({...params})
            
        }
        else{
            if(!searchParams.get('limit')){
                handleSearchParams('limit','15')
           
            }
            if(!searchParams.get('page_number')) { 
                handleSearchParams('page_number', '1')
            }
            if(!searchParams.get('sort')) {
                handleSearchParams('sort', `_id+desc`)
            }
            if(!searchParams.get('filter')) {
                handleSearchParams('filter', `true`)
            }
            if(!searchParams.get('organization_id')){
                handleSearchParams('organization_id',orgId)
            }
        }
        
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        
    }, [location]);

    useEffect(()=>{
        if(searchParams.size>=4){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-list-org-users');
        } else {
            setQueryParamsadmin('type=admin-list-org-users');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))    
            dispatch(handleIsUserScreen([orgView_Id,searchParams.get("organization_id")]));
                    
        }
       
        
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleCheckboxChange = (event, type) => {
        const { id, checked } = event.target;
        setFilterValues((prevState) => {
            const newState = { ...prevState };
            newState[type] = checked
                ? [...(newState[type] || []), id]
                : (newState[type] || []).filter((item) => item !== id);
            return newState;
        });
    };

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
    
        if (type) {
            // params.filter = "true";
    
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                status: filterValues.status,
                permission_access: filterValues.permission_access
            }));
    
            // Filter out empty values before updating searchParams
            const filteredStatus = filterValues.status && filterValues.status.length > 0
                ? filterValues.status.join(',')
                : null;
    
            const filteredPermissionAccess = filterValues.permission_access && filterValues.permission_access.length > 0
                ? filterValues.permission_access.join(',')
                : null;
    
            if (filteredStatus) {
                params['status'] = filteredStatus;
            } else {
                delete params['status'];
            }
    
            if (filteredPermissionAccess) {
                params['permission_access'] = filteredPermissionAccess;
            } else {
                delete params['permission_access'];
            }
    
            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues({
                status: [],
                permission_access: [],
                // Add other properties if needed
            });
    
            // Remove filter-related keys from searchParams
            delete params['status'];
            delete params['permission_access'];
            // delete params['filter'];
    
            setSearchParams({ ...params });
        }
    };
    

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        
        if((confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""&&confirmationState?.rowData?.status === 'active' && textAreaMsg.trim()=== '')||(confirmationState?.multirow==="deactive"&&(textAreaMsg.trim()===''))){ 
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        try {
            let body = { }
            if(confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""){
                {confirmationState?.rowData?.status === 'inactive' ?
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : ''
                    } : 
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : textAreaMsg 
                    } 
                }
            }
            else{
                confirmationState?.multirow==="deactive"?
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : textAreaMsg 
                    }
                    :
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : ''
                        
                    }
            }
            setLoading(true)
            
            

            const activationRes=await editUser({body})
            setLoading(false)
            
            if(activationRes?.error){
                setToastErrorMessage('Something went wrong. Please try again')
            }else{
                if(confirmationState?.multirow!==""&&confirmationState?.multirow!==undefined){
                    setToastmessage(`Organization users ${confirmationState?.multirow==="active"?"activated":"deactivated"} successfully`);
                }
                else{
                    setToastmessage(`Organization user ${confirmationState?.rowData?.status==="inactive"?"activated":"deactivated"} successfully`);
                }
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})
           
        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  

    // apply search function
    const handleOnSubmit = (e) => {        
        e.preventDefault();
    
        let searchString = '';
    
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `user_id` and `user_id_inverse` conditions
        if (providerSearch?.user_id && providerSearch?.user_id.trim()!=='') {
            const userIdPrefix = providerSearch.user_id_inverse ? 'ne:' : '';
            const formattedUserId = formatSearchValue(providerSearch?.user_id);
            searchString += `user_id=${userIdPrefix}${encodeURIComponent(formattedUserId)};`;
        }

        // Check for `user_name` and `user_name_inverse` conditions
        if (providerSearch?.user_name || providerSearch.user_name_domain) {
            const userNamePrefix = providerSearch.user_name_inverse ? 'ne:' : '';
            const userName = formatSearchValue(providerSearch.user_name || '');
            const userNameDomain = formatSearchValue(providerSearch.user_name_domain || '');
            searchString += `user_name=${userNamePrefix}${encodeURIComponent(userName)}@${encodeURIComponent(userNameDomain)};`;
        }

        // Check for `first_name` and `first_name_inverse` conditions
        if (providerSearch?.first_name && providerSearch?.first_name.trim()!=='') {
            const firstNamePrefix = providerSearch?.first_name_inverse ? 'ne:' : '';
            const formattedFirstName = formatSearchValue(providerSearch?.first_name);
            searchString += `first_name=${firstNamePrefix}${encodeURIComponent(formattedFirstName)};`;
        }

        // Check for `last_name` and `last_name_inverse` conditions
        if (providerSearch?.last_name && providerSearch?.last_name.trim()!=='') {
            const lastNamePrefix = providerSearch?.last_name_inverse ? 'ne:' : '';
            const formattedLastName = formatSearchValue(providerSearch?.last_name);
            searchString += `last_name=${lastNamePrefix}${encodeURIComponent(formattedLastName)};`;
        }

        // Check for `email_address` and `email_address_inverse` conditions
        if (providerSearch?.email_address || providerSearch.email_address_domain) {
            const emailAddressPrefix = providerSearch.email_address_inverse ? 'ne:' : '';
            const emailAddress = formatSearchValue(providerSearch.email_address || '');
            const emailAddressDomain = formatSearchValue(providerSearch.email_address_domain || '');
            searchString += `email_address=${emailAddressPrefix}${encodeURIComponent(emailAddress)}@${encodeURIComponent(emailAddressDomain)};`;
        }

        // Check for `mobile_number` and `mobile_number_inverse` conditions
        if (providerSearch?.mobile_number_code || providerSearch.mobile_number) {
            const mobileNumPrefix = providerSearch.mobile_number_inverse ? 'ne:' : '';
            const mobileCountryCode = formatSearchValue(providerSearch.mobile_number_code || '');
            const mobileNumber = formatSearchValue(providerSearch.mobile_number || '');
            searchString += `mobile_country_code-mobile_number=${mobileNumPrefix}${mobileCountryCode ? '+' : ''}${encodeURIComponent(mobileCountryCode)}-${encodeURIComponent(mobileNumber)};`;
        }

        // Check for `main_number` and `main_number_inverse` conditions
        if (providerSearch?.main_number_code || providerSearch.main_number) {
            const mainNumPrefix = providerSearch.main_number_inverse ? 'ne:' : '';
            const mainCountryCode = formatSearchValue(providerSearch.main_number_code || '');
            const mainNumber = formatSearchValue(providerSearch.main_number || '');
            searchString += `main_country_code-main_number=${mainNumPrefix}${mainCountryCode ? '+' : ''}${encodeURIComponent(mainCountryCode)}-${encodeURIComponent(mainNumber)};`;
        }
        const { created_day, created_month, created_year } = providerSearch || {};
        // Check if only some of the fields are filled
        const isPartialDateFilled = (created_day && (!created_month || !created_year)) || (created_month && (!created_day || !created_year)) || (created_year && (!created_day || !created_month));

        if (isPartialDateFilled) {
            setDatePartialFilled(true) 
            return;       
        } else if (created_day && created_month && created_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;

            // Create a Date object at midnight (00:00:00) UTC
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds (UTC)
            const epochDate = Math.floor(date.getTime() / 1000);
            const createdDatePrefix = providerSearch.created_date_inverse ? 'ne:' : ''; 

            // Add epoch to search string
            searchString += `created_at=${createdDatePrefix}${epochDate};`;
        }        

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: providerSearch.match === false ? 'and' : 'or', // Add search mode
            sort: currentParams.sort || '_id+desc', // Keep sort or set default
            page_number: 1, // Reset page number on new search
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setProSearchApplied());
    };
    
    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetProviderSearch());
        }
    }, [dispatch, searchApplied]);

    const handleSearchClose = () => {
        dispatch(resetProviderSearch()),
        setIsAdvancedSearchOpen(false) 
    }
   

    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Organization Users"}/>
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className='flex items-center mb-3 mt-1 px-6'>
                        <Link to="/manage-organizations"
                            state={location.state?.parentState??''}
                            onClick={handleSearchClose}
                        >
                            <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        <Link to={`/manage-organizations/${viewId}`}
                            onClick={handleSearchClose}
                        >
                            <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        <h1 className="text-sm font-normal text-[#008586]">List of Organization Users</h1>
                        {
                            userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }
                    </div>
                    <div className="px-6">
                        <TopBarIndividual 
                            title={'List of Organization Users'}
                            path={'/manage-admin-corporate/add-admin-corporate'}
                            AddButton={true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add User"}
                            menuBar={(data!==undefined&&data?.data?.length>0&&selectedRows?.length>0) ? true : false}
                            ApplyFilter={((searchParams.get("permission_access")===null&&searchParams.get("status")===null)&&(data?.data?.length===0 || data===undefined))?false:true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-organizations/manage-organization-users/add-organization-user'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID','Username','First Name','Last Name','Status','Email Address','Mobile Number','Main Number','Permission','Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportUsers={exportOrganizationUsers}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleCheckboxChange={handleCheckboxChange}
                            handleApplyFilter={handleApplyFilter}
                            isIdexport={true}
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Organization User list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay_OrgUser':'overlay-list-organizationUser'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}

                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false") || (searchParams.get("status")!==null||searchParams.get("permission_access")!==null) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count===0&&!searchParams.get("search")?<Emptyscreen
                                title={"Manage Organization Users"}
                                FirstPTag={"No Organization users added yet."}
                                SecondePTag={"Start managing by clicking 'Add user'"}
                                organizationUser={true}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                {confirmationState.isOpen  && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle= {confirmationState?.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==="active"?'Activate':'Deactivate'}
                                message = {confirmationState.rowData!==""?`Are you sure you want ${confirmationState?.rowData?.status==="inactive"? 'activate' : 'deactivate'} this Organization user?`:
                                    `Are you sure you want to ${confirmationState.multirow==='active'?'activate':'deactivate'} the following organization users?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {confirmationState.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==='active'?'Activate':'Deactivate'}
                                userList={confirmationState?.multirow===''?'':confirmationState?.multirow==="deactive"?(selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name):(selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name)}
                                loadingActivation={loading}
                            />
                        }
                    /> 
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
                {isAdvancedSearchOpen&&searchParams?.get('limit') &&
                <ProviderSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                    organizationUserSearch={true}
                />
                }
            </div>
        </>
   
    )
}